import React from 'react';
import { Grid } from '@material-ui/core';

import { FormSelect, FormTextField } from '../../../../components';

export const FilterByName = (props) => (
  <Grid item md={4} sm={4} xs={6}>
    <FormTextField
      {...props}
      id="api-apiproducts-filter-by-name"
      data-apim-test="api-apiproducts-filter-by-name"
    />
  </Grid>
);

export const FilterByAccessType = (props) => (
  <Grid item md={4} sm={4} xs={6}>
    <FormSelect
      {...props}
      id="api-apiproducts-filter-by-access-type"
      data-apim-test="api-apiproducts-filter-by-access-type"
      noNoneOption
      noNativeSelect
    />
  </Grid>
);
